<template>
    <div>
        <div style="position: relative; overflow: hidden;">
            <transition name="fade">
                <img :src="currentImage" :key="currentImage" :style="currentImageStyle" class="home-page-banner">
            </transition>
            <div class="row container" style="margin-top: 37px; margin-bottom: 37px;">
                <div class="col-xs-12 col-sm-9 col-md-6 bg-dark q-pa-xl strokeme rounded-borders" style="opacity: 90%; min-width: 275px;">
                    <h4 class="q-my-md">
                        Design Software For
                    </h4>
                    <h4 class="q-my-md">
                        <b>HVAC</b> and <b>PLUMBING</b> Systems
                    </h4>
                    <p style="font-size: 1rem;">
                        HVAC Loads &bull; Radiant Heating &bull; Snow Melt &bull; Plumbing Systems
                    </p>
                </div>
            </div>
        </div>

        <!-- Products -->
        <section>
            <div class="container">
                <div v-for="type in productTypes" :key="type.title">
                    <div class="text-title" :class="type.title == 'Other Products' ? 'q-mt-xl' : ''">{{ type.title }}</div>
                    <div class="row q-col-gutter-lg items-stretch">
                        <div v-for="prod in type.products" :key="prod.name"
                                class="col-xs-12 col-sm-6 col-md-4 text-center">
                            <q-card class="card-product full-height">
                                <q-card-section class="card-body" :class="{'q-pa-xl' : !screenSize.xs, 'q-pa-lg q-my-sm' : screenSize.xs}">
                                    <router-link :to="prod.path"><img :src="prod.logo" class="card-img-product" :title="prod.name" /></router-link>
                                    <div class="text-subtitle1 text-weight-medium text-primary">{{ prod.title }}</div>
                                    <div class="text-body2 q-mt-sm" v-html="prod.description" />
                                </q-card-section>
                                <div>
                                    <q-separator />
                                    <q-card-section class="bg-grey-2 q-py-md rounded-borders" :class="{'q-px-xl' : !screenSize.xs, 'q-px-lg' : screenSize.xs}">
                                        <div class="row q-col-gutter-sm justify-center">
                                            <div class="col-xs-12 col-md-auto">
                                                <q-btn color="primary"
                                                        :to="prod.path"
                                                        class="full-width"
                                                        label="Learn More" />
                                            </div>
                                            <div class="col-xs-12 col-md-auto">
                                                <q-btn v-if="prod.tutorial"
                                                        color="primary"
                                                        class="full-width"
                                                        :to="prod.tutorial"
                                                        label="Tutorial" />
                                            </div>
                                        </div>
                                    </q-card-section>
                                </div>
                            </q-card>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- ACCA Approved -->
        <section class="bg-grey-3 row justify-center">
            <div class="row col-xs-12 col-sm-5 items-center" :class="{'justify-center' : screenSize.lt.lg, 'justify-end' : !screenSize.lt.lg}">
                <div class="col-md-3 q-ma-lg">
                    <router-link to="/acca"><img :src="require('@/assets/img/logos/acca-powered.png')" title="Powered by ACCA Manual J" style="width: 11rem;" /></router-link>
                </div>
                <div class="col-md-7 acca-body q-mb-md  q-ma-lg">
                    <div class="text-title">Powered by ACCA Manual J<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span></div>
                    <p>
                        HeatCAD and LoopCAD are available in the
                        <span class="bold">MJ8 Edition</span>
                        for the ACCA<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span> Approved calculation of Manual J<span style="top: -0.4em; font-size: 0.8em; position: relative;">&reg;</span> (8th Edition, Version 2.50) residential
                        heating and cooling loads.
                    </p>
                    <div class="row" :class="{'justify-center q-px-xl' : screenSize.lt.lg}">
                        <q-btn color="primary"
                                to="/acca"
                                label="More Info" class="col-xs-12 col-sm-auto" />
                    </div>
                </div>
            </div>
            <!-- Verified CSA F280 -->
            <div class="row col-xs-12 col-sm-5 items-center" :class="{'justify-center' : screenSize.lt.lg, 'justify-start' : !screenSize.lt.lg}">
                <div class="col-md-3 q-ma-lg">
                    <router-link to="/f280"><img :src="require('@/assets/img/logos/f280-verified.png')" title="Verified F280 Software" style="width: 11rem;" /></router-link>
                </div>
                <div class="col-sm-12 col-md-7 f280-body q-mb-md  q-ma-lg">
                    <div class="text-title">Verified F280 Software</div>
                    <p>
                        LoopCAD and HeatCAD provide for easy, accurate and verified
                        <span class="bold">CSA F280-12</span>
                        residential heating and cooling load calculations.
                    </p>
                    <div class="row" :class="{'justify-center q-px-xl' : screenSize.lt.lg}">
                        <q-btn color="primary"
                                to="/f280"
                                label="More Info" class="col-xs-12 col-sm-auto" />
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="container">
                <div class="text-title"><router-link to="/news">Latest News</router-link></div>
                <q-timeline color="primary">
                    <q-timeline-entry v-for="article in articles" :key="article.id"
                                        :subtitle="article.dateCreated | date"
                                        :body="article.description">
                        <template v-slot:title>
                            <router-link :to="`/news/article/${article.id}`">{{ article.title }}</router-link>
                        </template>
                        <div>
                            <router-link :to="`/news/article/${article.id}`">Read More...</router-link>
                        </div>
                    </q-timeline-entry>
                    <div v-if="getArticlesPending" class="text-center">
                        <q-spinner color="primary"
                                    :thickness="2"
                                    size="3em" />
                    </div>
                </q-timeline>
                <div class="row">
                    <q-btn v-if="getArticlesData" label="See More News" color="primary" to="/news" class="col-xs-12 col-sm-auto" />
                </div>
            </div>
        </section>
        <about />
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import about from '@/components/About'
    import { productTypes } from '@/plugins/productTypes'

    export default {
        name: 'home',
        components: {
            about,
        },
        data() {
            return {
                articles: [],
                productTypes: productTypes,
                images: [
                    { src: require('@/assets/img/hero/Banner-WritingHomeModelConcept.jpg'), style: 'height: 100%; object-fit: cover; object-position: 85% 80%;' },
                    { src: require('@/assets/img/hero/Banner-GirlSmartThermostat.jpg'), style: 'height: 100%; width: 100%; object-fit: cover; object-position: 80% 30%;' },
                    { src: require('@/assets/img/hero/Banner-RenderedLoops.jpg'), style: 'height: 100%; width: 100%; object-fit: cover; object-position: 75% 55%;' },
                    { src: require('@/assets/img/hero/Banner-Feet.jpg'), style: 'width: 100%; height: 100%; object-fit: cover; object-position: 70% 80%;' },
                    { src: require('@/assets/img/hero/Banner-FamilyInLivingRoom.jpg'), style: 'height: 100%; width: 100%; object-fit: cover; object-position: 60% 70%;' },
                    { src: require('@/assets/img/hero/Banner-SkyBuildings.jpg'), style: 'height: 100%; object-fit: cover; object-position: 80% 50%;' },
                    { src: require('@/assets/img/hero/Banner-BlueprintRolls.jpg'), style: 'height: 100%; object-fit: cover; object-position: 100% 25%;' },
                    { src: require('@/assets/img/hero/Banner-Construction.jpg'), style: 'height: 100%; width: 100%; object-fit: cover; object-position: 100% 60%;' },
                    { src: require('@/assets/img/hero/Banner-GroupOfSchoolChildren.jpg'), style: 'height: 100%; width: 100%; object-fit: cover; object-position: 100% 63%;' },
                    { src: require('@/assets/img/hero/Banner-EngineersWorking.jpg'), style: 'height: 100%; width: 100%; object-fit: cover; object-position: 73% 45%;' },
                    { src: require('@/assets/img/hero/Banner-HomeModel.jpg'), style: 'height: 100%; width: 100%; object-fit: cover; object-position: 50% 50%;' },
                    //{ src: require('@/assets/img/hero/Banner-Loops.jpg'), style: 'height: 100%; object-fit: cover; object-position: 70% 90%;' },
                ],
                preloadedImages: [],
                currentImageIndex: 0,
            }
        },
        methods: {
            getArticles() {
                this.$store.dispatch('getArticles', 3).then(() => {
                    this.articles = this.getArticlesData?.slice(0, 3)
                })
            },
            async preloadImages() {
                const promises = this.images.map((image, index) => {
                    return new Promise((resolve) => {
                        const img = new Image();
                        img.src = image.src;
                        img.style = image.style;
                        img.onload = () => {
                            this.preloadedImages[index] = img;
                            resolve();
                        };
                    });
                });
                await Promise.all(promises);
            },
            startSlideshow() {
                setInterval(() => {
                    this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
                }, 9000)
            },
        },
        computed: {
            ...mapState([
                'getArticlesData',
                'getArticlesPending'
            ]),
            screenSize() {
                return this.$q.screen
            },
            currentImage() {
                return this.preloadedImages[this.currentImageIndex]?.src || this.images[this.currentImageIndex].src;
            },
            currentImageStyle() {
                return this.preloadedImages[this.currentImageIndex]?.attributes['style'].value || this.images[this.currentImageIndex].style;
            },
        },
        created() {
            this.getArticles()
            this.startSlideshow()
            this.preloadImages()
        },
    }
</script>
<style lang="scss" scoped>
    @import "../styles/quasar.scss";

    @media (max-width: $breakpoint-sm-max) {
        .acca-body {
            text-align: center;
        }

        .f280-body {
            text-align: center;
        }
    }

    .strokeme {
        color: white;
        text-shadow: 1px 1px 2px black;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 1.5s;
    }

    .fade-leave {
        opacity: 1;
    }

    .fade-enter {
        opacity: 0;
    }

    .home-page-banner {
        position: absolute;
        width: 100%;
    }

    </style>
